import styles from './Claim.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import claimPage from 'assets/claim_page.png'
import { FailedForm } from './FailedForm/FailedForm'


export function Claim() {
    const isFailed = true

    return (
        <div className={styles['wrapper']}>
            <div className={styles['content']}>
                {!isFailed ? (
                    <div className={styles['form']}>
                        <h1 className={styles['title']}>
                            Nona-Marie
                            <br />
                            committed a $5000 deposit to your name
                        </h1>
                        <div>
                            <article className={styles['item']}>
                                <div className={styles['icon']}>
                                    <Icon name='procent' />
                                </div>
                                <span>
                                    You will be collecting interest from this deposit
                                </span>
                            </article>
                            <article className={styles['item']}>
                                <div className={styles['icon']}>
                                    <Icon name='safe' />
                                </div>
                                <span>
                                    Deposit is the amount that Nona-Marie
                                    locked for growth.
                                </span>
                            </article>
                            <article className={styles['item']}>
                                <div className={styles['icon']}>
                                    <Icon name='coin_gold' />
                                </div>
                                <span>
                                    As the interest accrues towards
                                    Nona-Marie's deposit, it will be yours to claim
                                </span>
                            </article>
                        </div>
                        <div className={styles['buttons']}>
                            <span className={styles['button-title']}>
                                Authorize to claim interest
                            </span>
                            <Button
                                size='m'
                                type='dark'
                                iconName='google'
                                onClick={() => { }}
                            >
                                Continue with Google
                            </Button>
                            <Button
                                size='m'
                                type='dark'
                                iconName='metamask'
                                onClick={() => { }}
                            >
                                Continue with Metamask
                            </Button>
                        </div>
                    </div>

                ) : <FailedForm />
                }
            </div >
            <div className={styles['logo']}>
                <img
                    src={claimPage}
                    alt='drizzle pink'
                />
            </div>
        </div >
    )
}

